import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination, Box, Typography } from '@mui/material';
import { COLOR } from '../../styles/color';
import { StyledCustomPagination } from './index.style';

const CustomPagination = ({
  currentPage,
  limit,
  total,
  onChangePagination,
  display,
}) => {
  const { t } = useTranslation();
  const totalPages = Math.ceil(total / limit);

  return (
    <StyledCustomPagination>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography variant="body3" sx={{ color: COLOR.darkestBlue[100] }}>
          {t('paginationText', { display, total })}
        </Typography>
        <Pagination
          color="primary"
          className="pagination"
          page={currentPage}
          count={totalPages}
          onChange={(e, page) => onChangePagination(page)}
        />
      </Box>
    </StyledCustomPagination>
  );
};

export default CustomPagination;
